import React from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TableSortLabel,
  useTheme,
} from '@mui/material';

const UsersTable = ({data, onDelete, onEdit, onSortChange, order = 'desc', orderBy = 'id'}) => {
  const theme = useTheme();

  // Mapeamento entre headers e campos dos dados
  // IMPORTANTE: Os nomes aqui devem corresponder aos campos do backend
  // Note: 'id' no frontend corresponde a 'orb_account_id' no backend
  const getFieldName = (headerTitle) => {
    const headerMap = {
      'Status': 'status',
      'Nome': 'name',
      'Email': 'email',
      'Documento': 'document',
      'Perfil': 'type',
      'Representa': null, // Não ordenável (campo calculado)
      'Ações': null, // Não ordenável (botão)
    };
    return headerMap[headerTitle] || null;
  };

  // Handler para mudança de ordenação - comunica ao componente pai
  const handleRequestSort = (property) => {
    if (!onSortChange) return;
    
    // O backend usa 'orb_account_id' como campo 'id', mas aceita 'id' também
    // Vamos enviar 'id' e o backend mapeia para 'orb_account_id' se necessário
    const isAsc = orderBy === property && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';
    const newOrderBy = property;
    
    onSortChange(newOrderBy, newOrder);
  };

    return (
        <>
        <TableContainer className='table-container' component={Paper}>
            <Table size="small" className="basic-table">
            <TableHead className="basic-table-head">
                <TableRow>
                {['Status', 'Nome', 'Email', 'Documento', 'Perfil', 'Representa', 'Ações'].map((title, key) => {
                  const fieldName = getFieldName(title);
                  const isSortable = fieldName !== null;
                  
                  return (
                    <TableCell
                      key={key}
                      align="center"
                      style={{ color: '#F5F5F5' }}
                      sortDirection={orderBy === fieldName ? order : false}
                    >
                      {isSortable ? (
                        <TableSortLabel
                          active={orderBy === fieldName}
                          direction={orderBy === fieldName ? order : 'asc'}
                          onClick={() => handleRequestSort(fieldName)}
                          sx={{
                            '&.Mui-active': {
                              color: theme.palette.secondary.main,
                            },
                            '& .MuiTableSortLabel-icon': {
                              color: orderBy === fieldName 
                                ? `${theme.palette.secondary.main} !important` 
                                : 'rgba(255, 255, 255, 0.54)',
                            },
                            '&:hover': {
                              color: theme.palette.secondary.light,
                            },
                            '&:hover .MuiTableSortLabel-icon': {
                              color: `${theme.palette.secondary.light} !important`,
                            },
                            color: orderBy === fieldName 
                              ? theme.palette.secondary.main 
                              : 'inherit',
                          }}
                        >
                          {title}
                        </TableSortLabel>
                      ) : (
                        title
                      )}
                    </TableCell>
                  );
                })}
                </TableRow>
            </TableHead>
            <TableBody>
            {data?.length > 0 ? data.map((user, index) => {
                return (
                    <TableRow className='row' key={user.id || index}>
                        <TableCell>{user.status}</TableCell>
                        <TableCell>{user.name}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell>{user.document}</TableCell>
                        <TableCell>{user.type}</TableCell>
                        <TableCell>{user.contributor ? user.contributor : user.client ? user.client : null}</TableCell>
                        <TableCell>
                            <div style={{display: 'flex', gap: '8px', justifyContent: 'center'}}>
                                <Button variant='outlined' color='secondary' size='small' style={{cursor: 'pointer'}}
                                    onClick={() => onEdit(user)}>Editar</Button>
                                <Button variant='contained' color='secondary' size='small' style={{cursor: 'pointer'}}
                                    onClick={() => onDelete(user.id)}>Desabilitar</Button>
                            </div>
                        </TableCell>
                    </TableRow>
                )
            }) : null}
            </TableBody>
            </Table>
        </TableContainer>
        </>
    )
}

export default UsersTable;